export const meta = {
  id: 'fast-exponentiation',
  name: 'Fast Exponentiation',
  category: 'Math',
  complexity: {
    time: 'O(log n)',
    space: 'O(1)'
  },
  description: 'Fast Exponentiation computes x^n in O(log n) time using binary exponentiation, squaring the base and halving the exponent iteratively.'
};
